import {Component, OnInit} from '@angular/core';
import {FuncaoService} from "../../../services/funcao.service";
import {Funcao} from "../../../types/Funcao";

@Component({
  selector: 'app-funcoes',
  templateUrl: './funcoes.component.html',
  styleUrl: './funcoes.component.css'
})
export class FuncoesComponent implements OnInit {

  funcoes: Funcao[] = []

  constructor(private funcaoService: FuncaoService){}

  ngOnInit(){
    this.carregaFuncoes();
  }

  private carregaFuncoes(){
    this.funcaoService.getFuncoes().subscribe({
      next: (data) => {
        this.funcoes = data;
      },
      error: (error) => {
        console.error(error)
      }
    })
  }

}
